<template>
  <v-container fluid>
    <v-card max-width="400px" class="mt-4 mx-auto pa-4">
      <v-card-title>
        About FastTrack Pay Admin
      </v-card-title>

      <v-card-text>
        <p>
          FastTrack Pay Admin is a web based interface for managing all content within the FastTrack Pay system.
          This inlcudes operators, itemgroups, categories, tabs, products, sideorders, messages, barviews, points of sale and more.
        </p>

        <info-table
          :headers="infoHeaders"
          :value="metaData"
        ></info-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import InfoTable from '../components/InfoTable.vue';

export default {
  name: 'About',
  data() {
    return {
      infoHeaders: [
        {
          text: 'Version',
          value: 'version'
        },
        {
          text: 'Model',
          value: 'name'
        },
        {
          text: 'Manufacturer',
          value: 'manufacturer'
        }
      ]
    };
  },
  computed: {
    metaData() {
      return this.$store.state.metaData;
    }
  },
  components: {
    InfoTable
  }
}
</script>
